module.exports = __webpack_public_path__ + "static/media/apartment10.6513d748.png";